//Se importan los types de cada acción para usar los que se requieran
import { types } from '../types/types'

const typesConfig = [
	{ name: "logo_register" },
	{ name: "logo_navbar" },
	{ name: "logo_login" },
	{ name: "logo_footer" },
	{ name: "banner_politics" },
	{ name: "navbar_color" },
	{ name: "bg_screen" },
	{ name: "screen_text_color" },
	{ name: "alert_color" },
	{ name: "alert_text_color" },
	{ name: "bg_footer" },
	{ name: "footer_text_color" },
	{ name: "bg_btn_guardar" },
	{ name: "btn_guardar_text_color" },
	{ name: "bg_hoover_btn_guardar" },
	{ name: "btn_guardar_hoover_text_color" },
	{ name: "sala_perito" },
]

//Método para asignar cada valor al estado correspondiente
export const setAllConfig = (data) => {
	return async (dispatch) => {

		data.forEach((d) => {
			typesConfig.forEach((t) => {
				if (d.id === t.name) {

					switch (t.name) {
						case "logo_register":
							dispatch(setLogoRegister(d.url))
							break

						case "logo_navbar":
							dispatch(setLogoNavbar(d.url))
							break

						case "logo_login":
							dispatch(setLogoLogin(d.url))
							break

						case "logo_footer":
							dispatch(setLogoFooter(d.url))
							break

						case "banner_politics":
							dispatch(setBannerPolitics(d.url))
							break

						default: return null
					}
				}
			})
		})

	}
}

//Método para asignar cada valor de colores al estado correspondiente
export const setAllConfigColors = (data) => {
	return async (dispatch) => {
		let objectOfObjects = data.reduce((acc, item) => {
			// acc[item.id] = { code: item.code, name: item.name };
			acc[item.id] = item.code;
			return acc;
		}, {});
		dispatch(setColorsPlatform(objectOfObjects));
		// data.forEach((d) => {
		// 	typesConfig.forEach((t) => {
		// 		if (d.id === t.name) {
		// 			switch (t.name) {
		// 				case "navbar_color":
		// 					dispatch(setNavbarColor(d.code))
		// 					break

		// 				case "bg_screen":
		// 					dispatch(setBackgroundScreen(d.code))
		// 					break

		// 				case "screen_text_color":
		// 					dispatch(setScreenTextColor(d.code))
		// 					break

		// 				case "alert_color":
		// 					dispatch(setAlertColor(d.code))
		// 					break

		// 				case "alert_text_color":
		// 					dispatch(setAlertTextColor(d.code))
		// 					break

		// 				case "bg_footer":
		// 					dispatch(setBackgroundFooter(d.code))
		// 					break

		// 				case "footer_text_color":
		// 					dispatch(setTextColorFooter(d.code))
		// 					break

		// 				case "bg_btn_guardar":
		// 					dispatch(setBgBtnGuardar(d.code))
		// 					break

		// 				case "btn_guardar_text_color":
		// 					dispatch(setTextColorBTNGuardar(d.code))
		// 					break

		// 				case "bg_hover_btn_guardar":
		// 					dispatch(setBgHooverBtnGuardar(d.code))
		// 					break

		// 				case "btn_guardar_hoover_text_color":
		// 					dispatch(setTextColorBtnGuardar(d.code))
		// 					break

		// 				// case "banner_politics":
		// 				// 	dispatch(setBannerPolitics(d.url))
		// 				// 	break

		// 				default: return null
		// 			}
		// 		}
		// 	})
		// })
	}
}

export const setAllConfigRounded = (data) => {
	return async (dispatch) => {
		let objectOfObjects = data.reduce((acc, item) => {
			// acc[item.id] = { code: item.code, name: item.name };
			acc[item.id] = item.code;
			return acc;
		}, {});
		dispatch(setRoundedStylePlatform(objectOfObjects));
	}
}

export const setAllConfigPeritaje = (data) => {
	return async (dispatch) => {

		data.forEach((d) => {
			typesConfig.forEach((t) => {
				if (d.id === t.name) {

					switch (t.name) {
						case "sala_perito":
							dispatch(setUrlSalaPerito(d.url))
							break

						default: return null
					}
				}
			})
		})

	}
}

//Método para Set Logo Register
export const setLogoRegister = (logo) => ({
	type: types.loadLogoRegister,
	payload: logo
});

//Método para Set Logo Register
export const setLogoNavbar = (logo) => ({
	type: types.loadLogoNavbar,
	payload: logo
});

//Método para Set Logo Register
export const setLogoLogin = (logo) => ({
	type: types.loadLogoLogin,
	payload: logo
});

//Método para Set Logo Register
export const setLogoFooter = (logo) => ({
	type: types.loadLogoFooter,
	payload: logo
});

//Método para Set Logo Register
export const setBannerPolitics = (logo) => ({
	type: types.loadBannerPolitics,
	payload: logo
});

//Método para Set Color
export const setColorsPlatform = (colors) => ({
	type: types.loadColors,
	payload: colors
});

//Método para Set Rounded Style
export const setRoundedStylePlatform = (rounded) => ({
	type: types.loadRounded,
	payload: rounded
});

//Método para Set Color Navbar
export const setNavbarColor = (color) => ({
	type: types.loadNavbarColor,
	payload: color
});

//Método para Set Color Background Screen
export const setBackgroundScreen = (color) => ({
	type: types.loadBackgroundScreen,
	payload: color
});

//Método para Set Color Text Screen
export const setScreenTextColor = (color) => ({
	type: types.loadScreenTextColor,
	payload: color
});

//Método para Set Color Alert
export const setAlertColor = (color) => ({
	type: types.loadAlertColor,
	payload: color
});

//Método para Set Color Alert
export const setAlertTextColor = (color) => ({
	type: types.loadAlertTextColor,
	payload: color
});

//Método para Set Color Background Footer
export const setBackgroundFooter = (color) => ({
	type: types.loadBackgroundFooter,
	payload: color
});

//Método para Set Color Text Footer
export const setTextColorFooter = (color) => ({
	type: types.loadFooterTextColor,
	payload: color
});

//Método para Set Color Background BTN Guardar
export const setBgBtnGuardar = (color) => ({
	type: types.loadBgBtnGuardar,
	payload: color
});

//Método para Set Color Text BTN Guardar
export const setTextColorBTNGuardar = (color) => ({
	type: types.loadTextColorBTNGuardar,
	payload: color
});

//Método para Set Color Background BTN Guardar
export const setBgHooverBtnGuardar = (color) => ({
	type: types.loadBgHooverBtnGuardar,
	payload: color
});

//Método para Set Color Text Hoover BTN Guardar
export const setTextColorBtnGuardar = (color) => ({
	type: types.loadTextColorHooverBtnGuardar,
	payload: color
});

//Método para Set Url Sala Perito
export const setUrlSalaPerito = (url) => ({
	type: types.loadUrlPeritoSala,
	payload: url
});
//Método para cargar la inforamción de la db de consentimiento informado
export const setDataInformedConsent = (data) => ({
	type: types.loadDataInformedConsent,
	payload: data
});
//Método para cargar la inforamción de la db de las garantias
export const setDataAssurance = (data) => ({
	type: types.loadDataAssurance,
	payload: data
});
//Método para cargar la inforamción de la db de las recomendaciones
export const setDataRecommendations = (data) => ({
	type: types.loadDataRecommendations,
	payload: data
});
//Método para cargar la inforamción de la db de los tiempos de cancelacipon y reagendamiento
export const setDataTimes = (data) => ({
	type: types.loadDataTimes,
	payload: data
});
//Método para cargar la inforamción de la db de los reembolsos
export const setDataRefund = (data) => ({
	type: types.loadDataRefund,
	payload: data
});
//Método para cargar la inforamción de la db de los derechos
export const setDataRights = (data) => ({
	type: types.loadDataRights,
	payload: data
});
//Método para cargar la inforamción de la db de los deberes
export const setDataDuties = (data) => ({
	type: types.loadDataDuties,
	payload: data
});
//Método para cargar la inforamción de la db las preguntas frecuentes
export const setDataFaqs = (data) => ({
	type: types.loadDataFaqs,
	payload: data
});
//Método para cargar la información de la db del uso de nuestro sitio web
export const setDataUseOurWebsite = (data) => ({
	type: types.loadDataUseOurWebsite,
	payload: data
});
//Método para cargar la información de la db de seguridad de la información
export const setDataInformationSecurity = (data) => ({
	type: types.loadDataInformationSecurity,
	payload: data
})
//Método para cargar la información de la db de Usuario
export const setDataUser = (data) => ({
	type: types.loadDataUser,
	payload: data
})
//Método para cargar la información de la db de Modifiaciones
export const setDataModifications = (data) => ({
	type: types.loadDataModifications,
	payload: data
})
//Método para cargar la información de la db de las restricciones
export const setDataRestrictions = (data) => ({
	type: types.loadDataRestrictions,
	payload: data
})
//Método para cargar la información de la db de la Titularidad de los contenidos
export const setDataContents = (data) => ({
	type: types.loadDataContents,
	payload: data
})
//Método para cargar la información de la db de la Exclusión de las garantías y responsabilidades
export const setDataGuaranteesResponsabilities = (data) => ({
	type: types.loadDataGuaranteesResponsabilities,
	payload: data
})
//Método para cargar la información de la db de la Titularidad de los contenidos
export const setDataCookies = (data) => ({
	type: types.loadDataCookies,
	payload: data
})
//Método para cargar la información de la db de la Duración y terminacion
export const setDataDurationTermination = (data) => ({
	type: types.loadDataDurationTermination,
	payload: data
})
//Método para cargar la información de la db de la indemnización del usuario
export const setDataUserCompensation = (data) => ({
	type: types.loadDataUserCompensation,
	payload: data
})
//Método para cargar la información de la db de la legislación aplicable y jurisdicción 
export const setDataLegislationJurisdiction = (data) => ({
	type: types.loadDataLegislationJurisdiction,
	payload: data
})
//Método para cargar la información de la db de la Proteeción de datos
export const setDataProtection = (data) => ({
	type: types.loadDataProtection,
	payload: data
})
//Método para cargar la información de la db de las Políticad de México
export const setDataMexicoPolitics = (data) => ({
	type: types.loadDataMexicoPolitics,
	payload: data
})
//Método para cargar la información de la db de elementos de política 
export const setDataElementsPolitics = (data) => ({
	type: types.loadDataElementsPolitics,
	payload: data
})
//Método para cargar la información de la db de elementos de política 
export const setDataGlossaryTerms = (data) => ({
	type: types.loadDataGlossaryTerms,
	payload: data
})
//Método para cargar la información de la db de elementos de política 
export const setDataPrivacyNoticeMexico = (data) => ({
	type: types.loadDataPrivacyNoticeMexico,
	payload: data
})
//Método para cargar la información de las politicas de privacidad de Colombia  
export const setDataColPolitics = (data) => ({
	type: types.loadDataColPolitics,
	payload: data
})
//Método para cargar la información del glosario de Colombia
export const setDataGlossaryCol = (data) => ({
	type: types.loadDataGlossaryCol,
	payload: data
})
//Método para cargar la información del tratamiento de los datos personales (Colombia)
export const setDataProccesingPersonalData = (data) => ({
	type: types.loadDataproccesingPersonalData,
	payload: data
})
//Método para cargar la información de los derechos de los titulares (Colombia)
export const setDataRightsHolders = (data) => ({
	type: types.loadDataRightsHolders,
	payload: data
})
//Método para cargar la información de los deberes de los responsables y los encargados del tratamieto (Colombia)
export const setDataDutiesTreatment = (data) => ({
	type: types.loadDataDutiesTreatment,
	payload: data
})
//Método para cargar la información de las medidas de seguridad y medios y canales de atención (Colombia)
export const setDataSecurityMeasures = (data) => ({
	type: types.loadDataSecurityMeasures,
	payload: data
})
//Método para cargar la información de las imagenes del Carousel
export const setDataImagesCarousel = (data) => ({
	type: types.loadDataImagesCarousel,
	payload: data
})